import React, {useEffect, useState} from 'react'
import DQRatingFullReportView from "../../../views/ver_24.10/ProgramRating/DQRating/DQRatingFullReport.view";
import {useHistory, useParams} from "react-router-dom";
import {fetchRatingProgramService} from "../../../services/rating.service";
import Loader from "../../../ui_library/ver_24.10/Loader/Loader.comp";
import {APP_STATUS} from "../../../utils/constants";

const DQRatingFullReport = () => {
    const history = useHistory();
    const { programId } = useParams();
    const [pdfUrl, setPdfUrl] = useState(null);
    const [appStatusV3, setAppStatusV3] = useState(null);
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        setShowLoader(true);

        const fetchReportData = async () => {
            try {
                await fetchProgramReport();
            } catch (error) {
                // Handle error if needed
                console.error('Error fetching program report:', error);
            } finally {
                setShowLoader(false);
            }
        };

        fetchReportData().then(r => console.log(r));
    }, [programId]);

    const fetchProgramReport = async () => {
        const result = await fetchRatingProgramService(programId);
        if (result.data && result.data.program_application) {
            setAppStatusV3(result.data.program_application.app_status_v3);
            if (
                result.data.program_application.app_status_v3 < APP_STATUS.PROGRAM_SUMMARY_REPORT_COMPLETED
            ) {
                history.push(`/dq_rating/${programId}`);
            } else {
                setPdfUrl(result.data.program_application.report_file_url);
            }
        }
    };

    const data = {
        pdfUrl,
        appStatusV3,
    };

    // Actions handling business logic
    const actions = {
    };

    // Configuration options for visual appearance
    const options = {
    };

    if (showLoader) {
        return <Loader />;
    }

    return (
        <>
            <DQRatingFullReportView
                data={data}
                actions={actions}
                options={options}
            />
        </>
    );
}

export default DQRatingFullReport;